import request from "superagent";
import { find } from "lodash";
import moment from "moment";

import {
  SET_LICENSE_HISTORY,
  SET_FETCHING_LICENSE_HISTORY,
  SET_PURCHASE_HISTORY,
  SET_FETCHING_PURCHASE_HISTORY
} from "../index";

import selectRMuser from "../../../reselect/cart/selectRMuser";

import { fetchingCheckout } from "redux/actions/shopify";

export default () => async (dispatch, getState) => {
  const isProduction = process.env.REACT_APP_FUNK_URL === "https://www.jukinmedia.com";
  const Link = "https://mvv507n1ti.execute-api.us-west-2.amazonaws.com";
  const SHOPIFY_ADMIN_API = `${Link}/${isProduction ? "prod" : "dev"}`;

  dispatch({ type: SET_FETCHING_PURCHASE_HISTORY, payload: true });
  const { user } = getState().auth;
  request
    .get(SHOPIFY_ADMIN_API + "/order")
    .query({ forUser: user.username })
    .then((response) => {
      const { body } = response;
      let orders = [];
      let licenseList = [];
      const Digital = ["PERSONAL", "BASIC", "BASIC PRO", "SUPER", "SUPER PRO"];
      const Broadcast = ["STANDARD", "ENHANCED", "ULTRA"];

      if (body.statusCode === 200) {
        if (body.devMessage.orders.length > 0) {
          const findObject = (product, field) => find(product, { name: field });

          body.devMessage.orders.forEach((item) => {
            item.line_items.forEach((line) => {
              let findJvId =
                findObject(line.properties, "ID") || findObject(line.properties, "jvId");

              let findTitle =
                findObject(line.properties, "Title") || findObject(line.properties, "title");

              let findUsage = findObject(line.properties, "Content Usage");
              const splitTitle = line.title.split(" ");

              const expiration = moment(item.closed_at).add(12, "months");
              const today = moment(new Date());

              const isExpired = today > expiration;

              const duration = moment.duration(expiration.diff(today));
              const expiresOn = duration.asDays();
              if (line.gift_card) {
                findTitle = {
                  value: line.title
                };
              }

              if (
                !line.name.includes("Rights Management") &&
                line.fulfillment_service !== "gift_card" &&
                findJvId
              ) {
                const inDigital = Digital.includes(String(line.title).toUpperCase());
                const inBroadcast = Broadcast.includes(String(line.title).toUpperCase());
                const lookForType = inDigital ? "Digital" : inBroadcast ? "Broadcast" : "";

                let licenseType = String(lookForType ? lookForType : splitTitle[1]).toLowerCase();
                licenseType = licenseType.charAt(0).toUpperCase() + licenseType.slice(1);

                licenseList.push({
                  orderId: item.id,
                  jvid: findJvId ? findJvId.value : "---",
                  videoTitle: findTitle ? findTitle.value : "---",
                  expireDate: expiration,
                  expiresOn: expiresOn,
                  isExpired,
                  tier: lookForType ? line.title : splitTitle[0],
                  type: licenseType,
                  usage: findUsage && findUsage.value !== "Not Specified" ? findUsage.value : "---",
                  imgUrl: "https://thumbnails-dev.jukinmedia.com/thumbnail-1590038911991.jpg",
                  orderReceipt: item.order_status_url
                });
              }
            });
            const expiration = moment(item.closed_at).add(12, "months");
            orders.push({
              orderId: item.id,
              status: item.financial_status,
              product: "license",
              license: "Broadcast",
              tier: "Personal",
              purchaseDate: item.closed_at,
              expiryDate: expiration,
              price: item.total_price,
              balance: "$$$",
              line_items: item.line_items,
              fulfillments: item.fulfillments,
              imgUrl: "https://thumbnails-dev.jukinmedia.com/thumbnail-1590038911991.jpg",
              orderReceipt: item.order_status_url,
              cartToken: item.cart_token,
              checkoutToken: item.checkout_token
            });
          });
        }

        dispatch({ type: SET_LICENSE_HISTORY, payload: licenseList });
        dispatch({ type: SET_PURCHASE_HISTORY, payload: orders });

        const shopifyCheckoutId = localStorage.getItem("shopifyCheckoutId");
        const isRMuser = selectRMuser(getState().auth);
        if (shopifyCheckoutId !== null && !isRMuser) {
          dispatch(fetchingCheckout(shopifyCheckoutId));
        }
      }

      dispatch({ type: SET_FETCHING_LICENSE_HISTORY, payload: false });
      dispatch({ type: SET_FETCHING_PURCHASE_HISTORY, payload: false });
    })
    .catch((error) => {
      dispatch({ type: SET_FETCHING_PURCHASE_HISTORY, payload: false });
      console.log("error", error);
    });
};
